import { IconWrapper } from '../runtime';
export default IconWrapper('window', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 5.24976V3.24976C1.75 2.42133 2.42157 1.74976 3.25 1.74976H12.75C13.5784 1.74976 14.25 2.42133 14.25 3.24976V12.7498C14.25 13.5782 13.5784 14.2498 12.75 14.2498H10.75",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.75 8.96976C1.75 8.57211 2.07235 8.24976 2.47 8.24976H7.03C7.42764 8.24976 7.75 8.57211 7.75 8.96976V13.5298C7.75 13.9274 7.42764 14.2498 7.03 14.2498H2.47C2.07235 14.2498 1.75 13.9274 1.75 13.5298V8.96976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});